import { BorderBox } from "@/components/atoms/BorderBox";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { useSelectedItemsForSyncContext } from "@/features/survey_sync/context/selectedItemsForSyncContext";
import { SurveyCheckResultProvider } from "@/features/survey_sync/context/surveyCheckResultContext";
import { SurveyCheckResult } from "@/features/survey_sync/types/syncCheckResult";
import { CheckedState } from "@radix-ui/react-checkbox";
import { ChevronsUpDown } from "lucide-react";
import { QuestionCheckResultItem } from "../QuestionCheckResultItem";
import { SurveyLevelChange } from "../SurveyLevelChange";

export function SurveyCheckResultItem(props: SurveyCheckResult) {
    const { selectedItemsForSync, setSelectedItemsForSync } = useSelectedItemsForSyncContext();

    const existsOnTheSelectedItemsList = selectedItemsForSync.hasOwnProperty(props.surveyInstance.id);
    const hasAllQuestionsSelected =
        existsOnTheSelectedItemsList
        && props.questionsToSync.length === selectedItemsForSync[props.surveyInstance.id]?.questionsToSync?.length
        && props.questionsToDelete?.length === selectedItemsForSync[props.surveyInstance.id]?.questionsToDelete?.length
    const hasSomeQuestionsSelected = existsOnTheSelectedItemsList
        && (selectedItemsForSync[props.surveyInstance.id]?.questionsToSync?.length! > 0
            || selectedItemsForSync[props.surveyInstance.id]?.questionsToDelete?.length! > 0
        )
    const isAllSelected = hasAllQuestionsSelected;
    const isSomeSelected = !hasAllQuestionsSelected && hasSomeQuestionsSelected;
    const checkboxState: CheckedState = isAllSelected ? true : isSomeSelected ? "indeterminate" : false;
    const handleCheckboxChange = () => {
        if (existsOnTheSelectedItemsList) {
            const newSelected = { ...selectedItemsForSync };
            delete newSelected[props.surveyInstance.id];
            setSelectedItemsForSync(newSelected);
        } else {
            setSelectedItemsForSync({
                ...selectedItemsForSync,
                [props.surveyInstance.id]: {
                    survey: {
                        name: true,
                        description: true,
                    },
                    questionsToSync: props.questionsToSync.map(q => q.templateQuestion?.id).filter(id => id !== undefined),
                    questionsToDelete: props.questionsToDelete?.map(q => q.instanceQuestion?.id).filter(id => id !== undefined),
                },
            });
        }
    };
    console.log(props.questionsToDelete)
    return (
        <SurveyCheckResultProvider value={props}>
            <BorderBox size={"xs"} className="flex flex-col items-start" icon={false}>
                <div className="flex items-center justify-between w-full">
                    <div className="">
                        <h3 className="flex flex-wrap gap-1 text-sm">
                            <span className="">Survey:</span>
                            <span className="font-semibold">{props.surveyInstance.name}</span>
                        </h3>
                    </div>
                    <div className="flex items-center gap-2">
                        <p>Sync entire survey</p>
                        <Checkbox
                            checked={checkboxState}
                            onCheckedChange={handleCheckboxChange}
                        />
                    </div>
                </div>
                {props.surveyLevelChanges && props.surveyLevelChanges.length > 0 && (
                    <Collapsible className="w-full">
                        <div className="flex flex-col w-full gap-2">

                            <BorderBox variant={"info"} className="flex justify-between w-full" size="xs">
                                <h4 className="">There are {props.surveyLevelChanges.length} changes to survey</h4>
                                <CollapsibleTrigger asChild>
                                    <Button variant="outline" size="action"><ChevronsUpDown size={14} /></Button>
                                </CollapsibleTrigger>
                            </BorderBox>

                            <CollapsibleContent>
                                <BorderBox className="flex flex-col w-full gap-2 bg-white">
                                    {props.surveyLevelChanges?.map((change, index) => (<SurveyLevelChange key={index} change={change} />))}
                                </BorderBox>
                            </CollapsibleContent>

                        </div>
                    </Collapsible>
                )}
                <div className="flex flex-col w-full gap-2 pl-2">
                    {props.questionsToSync?.map((question, index) => (
                        <QuestionCheckResultItem
                            key={question.instanceQuestion?.id || question.templateQuestion?.id || index}
                            instanceCrmSystem={props.instanceCrmSystem}
                            templateCrmSystem={props.templateCrmSystem}
                            {...question}
                        />
                    ))}
                    {props.questionsToDelete?.map((question, index) => (
                        <QuestionCheckResultItem
                            key={question.instanceQuestion?.id || question.templateQuestion?.id || index}
                            instanceCrmSystem={props.instanceCrmSystem}
                            templateCrmSystem={props.templateCrmSystem}
                            {...question}
                        />
                    ))}
                </div>
            </BorderBox>
        </SurveyCheckResultProvider>
    )
}